import * as React from 'react';
// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import classNames from 'classnames';

import {ButtonCard} from '../card/button-card';
import {colors} from '../colors/colors';
import type {ColorName} from '../colors/colors';
import {GlossaryBookmarkIcon, MinimizeIcon, TickCircleIcon} from '../icon';
import {Body} from '../typography/body';

import type {CueCardCta} from './cue-card';
import {getCta, getDescription, onCardClick, getThumbnail} from './helpers';

import styles from './cue-card-compact.module.css';

type Props = {
    title: string;
    description?: string | React.ComponentType<any>;
    cta?: CueCardCta;
    thumbnailIllustration?: string | React.ReactNode;
    thumbnailPosition?: 'full' | 'centered';
    thumbnailBackgroundColor?: ColorName;
    withBookmarkIcon?: boolean;
    onMinimize?: () => void;
    history: RouterHistory;
    isComplete?: boolean; // If true, the card will have a green background and a green check in the corner
};

export function CueCardCompact(props: Props) {
    const {thumbnailPosition = 'centered'} = props;

    const containerStyle = classNames(styles['thumbnail-container'], {
        [styles['thumbnail-container--full']]: thumbnailPosition === 'full',
    });

    const hasPlayButton = props.cta && props.cta.onClick && props.cta.actionType === 'video';

    return (
        <ButtonCard
            isFullWidth={true}
            // @ts-expect-error
            onClick={props.cta ? () => onCardClick(props.cta, props.history) : undefined}
        >
            <div className={styles['content-container']}>
                {(props.thumbnailBackgroundColor || props.thumbnailIllustration) && (
                    <div
                        style={{
                            backgroundColor:
                                props.thumbnailBackgroundColor &&
                                colors[props.thumbnailBackgroundColor],
                        }}
                        className={containerStyle}
                    >
                        {getThumbnail(
                            props.thumbnailIllustration,
                            hasPlayButton,
                            props.cta && props.cta.onClick
                        )}
                    </div>
                )}
                {props.isComplete && (
                    <div className={styles.complete}>
                        <TickCircleIcon size={16} color={colors.green} alignCenter={true} />
                    </div>
                )}
                {props.withBookmarkIcon && (
                    <span className={styles['bookmark-icon-container']}>
                        <GlossaryBookmarkIcon size={26} wrapWithDiv={false} />
                    </span>
                )}
                {props.onMinimize && (
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            if (props.onMinimize) {
                                props.onMinimize();
                            }
                        }}
                        className={styles['minimize-button']}
                    >
                        <MinimizeIcon size={12} wrapWithDiv={false} />
                    </div>
                )}
                <div className={styles['text-container']}>
                    <Body color='dark' isBold={true}>
                        {props.title}
                    </Body>
                    {props.description ? <div>{getDescription(props.description)}</div> : undefined}
                    {getCta(props.cta)}
                </div>
            </div>
        </ButtonCard>
    );
}
